module.exports = __webpack_public_path__ + "img/p28.10b3b35a.svg";